





































































































import {
	computed,
	defineComponent,
	PropType,
	ref,
} from '@vue/composition-api';
import { UserSearchItem } from '@front-app/services/UserApi/UserModel';
import { UserAvatarStore } from '@front-app/store/singletons/User';
import { chunk } from '@front-app/util/array';
import { getUsername } from '@front-app/util/user';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import UserAvatar from '@front-app/components/user/avatar.vue';
import IconButton from '@front-app/components/buttons/IconButton.vue';
import UserLink from '@front-app/components/buttons/UserLink.vue';
import LoaderState from '../LoaderState.vue';

const MEMBER_PAGE_LENGTH = 4;

export default defineComponent({
	components: {
		FontAwesomeIcon,
		UserAvatar,
		IconButton,
		UserLink,
		LoaderState,
	},
	props: {
		isLoading: Boolean,
		members: {
			type: Array as PropType<UserSearchItem[]>,
			required: true,
		},
	},
	setup(props, ctx) {
		const numMemberPages = computed(() => Math.ceil(props.members.length / MEMBER_PAGE_LENGTH));
		const pagesOfMembers = computed(() => chunk(props.members, MEMBER_PAGE_LENGTH));
		const currentMemberPage = ref(0);
		const getUsernameInternal = (user: UserSearchItem): string => getUsername(ctx.root.$t.bind(ctx.root), user);

		return {
			numMemberPages,
			pagesOfMembers,
			currentMemberPage,
			getAvatar: UserAvatarStore.get,
			fetchAvatar: UserAvatarStore.fetch,
			getUsername: getUsernameInternal,
		};
	},
});
